import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useState } from "react";
import Header from "./components/Header";
import ToggleBar from "./components/ToggleBar"; // ADD THIS
import InfoSection from "./components/InfoSection";
import ConverterCard from "./components/ConverterCard";
import ModeToggle from "./components/ModeToggle";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  const [mode, setMode] = useState("BS2AD");
  const [theme, setTheme] = useState("light");
  const [infoOpen, setInfoOpen] = useState(false); // FOR TOGGLE BAR

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className={theme === "dark" ? "dark-mode" : "light-mode"} style={{ minHeight: "100vh" }}>
        <Header />
        <ToggleBar isOpen={infoOpen} setIsOpen={setInfoOpen}/>   {/* Toggle switch */}
        <InfoSection open={infoOpen} />                         {/* Panel */}
        <ModeToggle theme={theme} setTheme={setTheme} />
        <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
          <button className={mode === "BS2AD" ? "tab-active" : "tab"} onClick={() => setMode("BS2AD")}>BS → AD</button>
          <button className={mode === "AD2BS" ? "tab-active" : "tab"} onClick={() => setMode("AD2BS")}>AD → BS</button>
        </div>
        <ConverterCard mode={mode} />
        <Footer />
      </div>
    </LocalizationProvider>
  );
}

export default App;
